import { useLanguage } from "@languages/index"
import Button from "components/button"
import TextInputField from "components/textInput"
import React, { useEffect, useState } from "react"
import { X } from "react-feather"
import { connect } from "react-redux"
import { mapDispatchProps, mapStateToProps } from "store/store"

export const TYPES = {
  DEFAULT: 1,
  T_SHIRTS: 2,
  UNDERWAER: 3,
  REELS: 4,
}

const SeedingWithCommissionsAlert = (props: any) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.component.seedingWithCommissionsAlert }

  const [productCount, setProductCount] = useState(1)
  const [honorarium, setHonorarium] = useState(30000)
  const [isHidden, setIsHidden] = useState(false)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const [title, setTitle] = useState(languageTexts._title)
  const [body, setBody] = useState(languageTexts._body(props.settings.currencyText))

  const productsCountOptions = languageTexts.products_count_options
  const amountOptions = languageTexts.amount_options
  const totalBudget = productCount * honorarium

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    switch (props.type) {
      default:
      case TYPES.DEFAULT:
        setTitle(languageTexts._title)
        setBody(languageTexts._body(props.settings.currencyText))
        break
      case TYPES.T_SHIRTS:
        setTitle(languageTexts._title_for_shirts)
        setBody(languageTexts._body(props.settings.currencyText))
        break
      case TYPES.UNDERWAER:
        setTitle(languageTexts._title_for_underwear)
        setBody(languageTexts._body(props.settings.currencyText))
        break
      case TYPES.REELS:
        setTitle(languageTexts._title_for_reels)
        setBody(languageTexts._body(props.settings.currencyText))
        break
    }
  }, [props.type])

  const handleProductCountChange = (value) => {
    setProductCount(parseInt(value))
  }

  const handleHonorariumChange = (value) => {
    setHonorarium(parseInt(value))
  }

  const closeOverlays = () => {
    if (props.preferences.isMobile) {
      props.closeSheet()
    } else {
      props.closePopup()
    }
  }

  const handleHideClick = () => {
    setIsHidden(true)
    props.onBlock ? props.onBlock() : null
    closeOverlays()
  }

  if (isHidden) {
    return null
  }

  return (
    <div
      className="relative bg-white p-[50px] rounded-lg shadow-md max-h-[80vh] overflow-scroll"
      style={{ width: windowWidth < 480 ? `${windowWidth}px` : "480px" }}
    >
      <div className="flex flex-col">
        <div
          className="absolute right-0 top-0 p-[30px] cursor-pointer"
          onClick={() => {
            closeOverlays()
          }}
        >
          <X strokeWidth={1} />
        </div>
        <div className="flex flex-col">
          <h2 className="text-[22px] font-bold mb-[30px]">{title}</h2>
          <div className="text-[15px] mb-[30px]">{body}</div>
          {/* <div className="mb-[30px]">
            <h3 className="text-md font-bold mb-2">{languageTexts.try_calculate}</h3>
            <div className="flex items-center mb-[50px]">
              <div className="flex flex-row w-full gap-[8px] items-center">
                <div className="flex flex-col w-full relative gap-[10px]">
                  <TextInputField
                    className="flex flex-row w-full h-[48px]"
                    bordered
                    textAlign={"right"}
                    placeholder={"0"}
                    value={productCount}
                    onChangeText={(value) => {
                      let numericValue = value.replace(/[^0-9]/g, "")
                      const numV = parseInt(numericValue || 0)
                      handleProductCountChange(numV)
                    }}
                    unit={languageTexts.products_count_unit}
                  />

                  <div
                    className="absolute flex flex-row w-full justify-between px-[4px]"
                    style={{
                      top: "calc(100% + 4px)",
                    }}
                  >
                    {productsCountOptions.map((option) => {
                      return (
                        <div className="relative flex flex-row">
                          <span
                            className="underline underline-offset-2 cursor-pointer flex flex-row text-[13px] text-[#999999]"
                            onClick={() => {
                              setProductCount(option.value)
                            }}
                          >
                            {option.name}
                            {languageTexts.products_count_unit}
                          </span>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex items-center mb-[50px]">
              <div className="flex flex-row w-full gap-[8px] items-center">
                <div className="flex flex-col w-full relative gap-[10px]">
                  <TextInputField
                    className="flex flex-row w-full h-[48px]"
                    bordered
                    textAlign={"right"}
                    placeholder={"0"}
                    value={honorarium / 10000}
                    onChangeText={(value) => {
                      let numericValue = value.replace(/[^0-9]/g, "")
                      const numV = parseInt(numericValue || 0)
                      handleHonorariumChange(numV * 10000)
                    }}
                    unit={languageTexts.amount_currency_unit}
                  />

                  <div
                    className="absolute flex flex-row w-full justify-between px-[4px]"
                    style={{
                      top: "calc(100% + 4px)",
                    }}
                  >
                    {amountOptions.map((option) => {
                      return (
                        <div className="relative flex flex-row">
                          <span
                            className="underline underline-offset-2 cursor-pointer flex flex-row text-[13px] text-[#999999]"
                            onClick={() => {
                              setHonorarium(option.value)
                            }}
                          >
                            {option.name}
                            {languageTexts.amount_currency_unit}
                          </span>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div className="text-right">
              <span className="text-lg font-bold">
                {languageTexts.calculate_result}
                {totalBudget.toLocaleString()}
                {languageTexts.calculate_unit}
              </span>
            </div>
          </div> */}
          {/* <div className="flex flex-col gap-[15px] w-full"> */}
          {/* <Button
              text={languageTexts.submit_inquiery}
              buttonColor={"black"}
              textColor={"white"}
              onClick={() => {
                props.onSubmit ? props.onSubmit() : null
              }}
            /> */}

          {/* {props.hideBlockButton ? null : (
              <button className="w-full text-center underline text-[#999999] text-[13px] text-underline" onClick={handleHideClick}>
                {languageTexts.block_until_next_week}
              </button>
            )} */}
          {/* </div> */}
        </div>
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(SeedingWithCommissionsAlert)
